import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apply-instructor',
  templateUrl: './apply-instructor.component.html',
  styleUrls: ['./apply-instructor.component.scss']
})
export class ApplyInstructorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
